module.exports = __webpack_public_path__ + "img/ortofoto.6bfc21b2.png";